import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  enableInviteButton: false,
  inviteButtonCooldownActive: false,
  inviteButtonClicked: false,
  status: false,
  menuItemDisableOnSnow: true,
  sessionID: null
};

const InviteReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  switch (type) {
    case ACTION_TYPES.SET_INVITE_BUTTON_COOLDOWN:
      return {
        ...state,
        inviteButtonCooldownActive: payload || false,
        enableInviteButton: payload ? false : state.enableInviteButton
      };
    case ACTION_TYPES.ENABLE_INVITE_BUTTON:
      return {
        ...state,
        enableInviteButton: state.inviteButtonCooldownActive ? false : payload || false
      };
    case ACTION_TYPES.INVITE_BUTTON_CLICKED:
      return {
        ...state,
        inviteButtonClicked: payload.inviteButtonClicked,
        status: payload.status,
        loading: payload.loading || false
      };
    case ACTION_TYPES.SET_MENU_ITEM_DISABLE:
      return {
        ...state,
        menuItemDisableOnSnow: payload || false
      };
    case ACTION_TYPES.SET_TPLC_SESSIONID:
      return {
        ...state,
        sessionID: payload.sessionID
      };
    default:
      return state;
  }
};

export default InviteReducer;
